import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";  // v2.0.11 — init i18next avant App
import App from "@/App";
import { AuthProvider } from "@/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import AutoTranslator from "@/components/AutoTranslator";
import { Toaster } from "sonner";

// Avertissement navigateur bénin (Radix / Recharts) : ne pas déclencher l'overlay d'erreur en développement
window.addEventListener("error", (e) => { if (String(e.message || "").includes("ResizeObserver loop")) e.stopImmediatePropagation(); }, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CurrencyProvider>
        <App />
        <AutoTranslator />
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: {
              fontFamily: "'IBM Plex Sans', sans-serif",
              borderRadius: "4px",
            },
          }}
        />
      </CurrencyProvider>
    </AuthProvider>
  </React.StrictMode>
);
